import React from 'react'
import { Outlet } from 'react-router'
import Header from '../header/header'
import SideBar from '../sidebar/sideBar'

interface Props { }

function DashboardLayout(props: Props) {
    const { } = props

    return (
       <>
            

            <div className="flex bg-[#F7F7FB] h-screen w-full overflow-x-hidden">
                <SideBar />

                <main className="flex-1 min-w-0 min-h-screen h-full lg:border-l-8 border-black overflow-hidden">
                    <div className="rounded-t-[8px] h-full flex flex-col">
                        <div className="flex-1 overflow-auto w-full bw-scroll">
                            <Outlet />
                        </div>
                    </div>
                </main>
            </div>
       
        </>
    )
}

export default DashboardLayout
